import React from "react";
import type { StrategyTimeline } from "../../../types/strategy-detail";
import { HiChevronDown } from "react-icons/hi";

const ChartLegend = ({
  timeline,
  benchmarkDropdownRef,
  isBenchmarkDropdownOpen,
  toggleBenchmarkDropdown,
  availableBenchmarks,
  selectedBenchmark,
  handleBenchmarkSelect,
  strategyColor,
  benchmarkColor,
}: {
  timeline: StrategyTimeline;
  benchmarkDropdownRef: React.RefObject<HTMLDivElement | null>;
  isBenchmarkDropdownOpen: boolean;
  selectedBenchmark: string;
  availableBenchmarks: { name: string; value: string }[];
  toggleBenchmarkDropdown: () => void;
  handleBenchmarkSelect: (value: string) => void;
  // Actual colors ApexCharts assigned to each series (undefined when that
  // series isn't actually plotted) - passed in rather than hardcoded here
  // so the legend can never drift out of sync with the chart.
  strategyColor?: string;
  benchmarkColor: string;
}) => {
  return (
    <div className="flex items-center gap-6 mt-4 justify-center">
      {strategyColor && (
        <div className="flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: strategyColor }}
          ></div>
          <span className="text-sm text-gray-700">{timeline.strategyName}</span>
        </div>
      )}
      <div
        className="flex items-center gap-2 relative"
        ref={benchmarkDropdownRef}
      >
        <div
          className="w-3 h-3 rounded-full"
          style={{ backgroundColor: benchmarkColor }}
        ></div>
        <button
          onClick={toggleBenchmarkDropdown}
          className="flex items-center gap-1 text-sm cursor-pointer px-2 py-1 rounded-md border transition-colors text-gray-700 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 border-gray-200"
        >
          <span>
            {
              availableBenchmarks.find((b) => b.value === selectedBenchmark)
                ?.name
            }
          </span>
          <HiChevronDown
            size={14}
            className={`transition-transform ${
              isBenchmarkDropdownOpen ? "rotate-180" : ""
            }`}
          />
        </button>

        {/* Benchmark Dropdown */}
        {isBenchmarkDropdownOpen && (
          <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20">
            <div className="py-1">
              {(availableBenchmarks || []).map((benchmark) => (
                <button
                  key={benchmark.value}
                  onClick={() => handleBenchmarkSelect(benchmark.value)}
                  className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer whitespace-nowrap ${
                    selectedBenchmark === benchmark.value
                      ? "bg-blue-50 text-blue-700"
                      : "text-gray-700"
                  }`}
                >
                  {benchmark.name}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartLegend;
